// react
import { ReactNode } from 'react';

// mui
import { Box, Container, Grid, Paper, Typography } from '@mui/material';

// logos
import { LogoFundsChainAlt } from '../../img/LogoFundsChainAlt';

// props
export interface GatewayProps {
	children: ReactNode;
	title?: string;
}

export const Gateway = ({ children, title }: GatewayProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					backgroundColor: theme.palette.secondary.main,
					width: '100%',
					minHeight: '100vh',
				};
			}}>
			<Grid
				container
				spacing={0}
				direction="row"
				alignItems="center"
				justifyContent="center"
				sx={{ minHeight: '100vh' }}>
				<Grid item xs={12} md={6.5} lg={5} xl={4.5}>
					<Container>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Paper
									sx={(theme) => {
										return {
											padding: theme.spacing(2),
											[theme.breakpoints.up('md')]: {
												padding: theme.spacing(4),
											},
										};
									}}>
									<Grid container spacing={3}>
										<Grid item xs={12}>
											<Grid container justifyContent="center">
												<Grid item>
													<LogoFundsChainAlt mode="dark" width={200} />
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12}>
											<Grid container justifyContent="center">
												<Grid item>
													<Typography component="h3" variant="h4">
														{title}
													</Typography>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12}>
											{children}
										</Grid>
									</Grid>
								</Paper>
							</Grid>
						</Grid>
					</Container>
				</Grid>
			</Grid>
		</Box>
	);
};
